import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import AuthStore from '../../store/AuthStore';
import shortLogo from '../../assets/images/shortLogo.png';
import PersonIcon from '@mui/icons-material/Person';
import { Collapse, Drawer, Stack, styled, SwipeableDrawer } from '@mui/material';
import { useTheme } from '@emotion/react';
import Divider from '@mui/material/Divider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsIcon from '@mui/icons-material/Settings';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import TaskIcon from '@mui/icons-material/Task';
import { ExpandLess, ExpandMore, Schema } from '@mui/icons-material';
import UserStore from '../../store/UserStore';

const pages = ['Home'];
const settings = ['Logout'];

export const AppNavbarOld = observer(({}) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    AuthStore.logout();
  };
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const theme = useTheme();
  const drawerWidth = 240;
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
  }));

  const [toggleConfigurations, setToggleConfigurations] = useState(false);

  const handleToggleConfigurationSubItems = () => {
    setToggleConfigurations(!toggleConfigurations);
  };

  return (
    <AppBar id="lm-app-nav-bar" position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            sx={{
              display: { xs: 'flex', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
              cursor: 'pointer',
            }}
          >
            <img src={shortLogo} style={{ height: '3rem', marginTop: '4px' }} alt="app-logo" />
          </Typography>
          <Stack direction={'row'}>
            <Button key={'Home'} onClick={() => navigate('/home')} sx={{ my: 2, color: 'white', display: 'block' }}>
              {'Home'}
            </Button>
            <Button key={'Status'} onClick={() => navigate('/status')} sx={{ my: 2, color: 'white', display: 'block' }}>
              {'Status'}
            </Button>
          </Stack>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}></Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="User Management">
              <IconButton onClick={handleDrawerOpen} sx={{ p: 0 }}>
                {UserStore.userImage ? (
                  <Avatar alt={AuthStore.userDetails.Name} src={UserStore.userImage}></Avatar>
                ) : (
                  <Avatar alt={AuthStore.userDetails.Name}>
                    <PersonIcon></PersonIcon>
                  </Avatar>
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </Container>
      <SwipeableDrawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
          },
        }}
        anchor="right"
        open={open}
        onOpen={() => {}}
        onClose={handleDrawerClose}
      >
        {/* <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
          <Button sx={{color: 'rgba(0, 0, 0, 0.54)'}} endIcon={<LogoutIcon />} onClick={handleLogout}>
            Logout
          </Button>
        </DrawerHeader> */}
        <Stack sx={{ py: '10px' }} alignItems={'center'}>
          <Avatar alt="Remy Sharp" sx={{ width: 110, height: 110 }}>
            <PersonIcon sx={{ fontSize: 82 }}></PersonIcon>
          </Avatar>
        </Stack>
        <List>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <ManageAccountsIcon />
              </ListItemIcon>
              <ListItemText primary={'User Management'} />
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton onClick={handleToggleConfigurationSubItems}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary={'Configuration'} />
              {toggleConfigurations ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </ListItem>
          <Collapse in={toggleConfigurations} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemIcon>
                  <TaskIcon />
                </ListItemIcon>
                <ListItemText primary="Task Priority" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemIcon>
                  <Schema />
                </ListItemIcon>
                <ListItemText primary="Workflow Stages" />
              </ListItemButton>
            </List>
          </Collapse>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <AllInclusiveIcon />
              </ListItemIcon>
              <ListItemText primary={'Create Pipeline'} />
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary={'Logout'} />
            </ListItemButton>
          </ListItem>
          <Divider />
        </List>
      </SwipeableDrawer>
    </AppBar>
  );
});
